<template>
	<div class="paymentOrderCon">
		<div id="big">
			<div id="header">
				<img id="imgFanhui" @click="fanhui" src="../../../../assets/fanhui.png" />
				支付订单
			</div>
			<div id="main">
				<div class="table-main">
					<p>
						<a>购买项目</a>
						<span v-text="form.subsystemName"></span>
					</p>
				</div>
				<div class="table-main">
					<p >
						<a>姓名</a>
						<span v-text="form.studentName"></span>
					</p>
				</div>
				<div class="table-main" @click="btn_show">
					<div class='table_time time_sct'>
						<div>学习开始时间</div>
						<div class='createTime'>
                 <div class='iconTime'>{{startTime}}</div>
                  <div class='iconsvg1'>
                      <svg t="1631064798758" class="icon iconsvg" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2388" width="18" height="18"><path d="M629.963157 511.976464 282.01449 848.324932c-20.50808 19.85828-20.50808 51.997258 0 71.792093 20.507056 19.826558 53.778834 19.826558 74.28589 0l385.061936-372.252189c20.47738-19.825534 20.47738-51.981908 0-71.745021L356.30038 103.882975c-10.285251-9.91379-23.728424-14.869662-37.173644-14.869662-13.446243 0-26.889417 4.956895-37.112246 14.901385-20.50808 19.826558-20.50808 51.919487 0 71.746044L629.963157 511.976464" p-id="2389" fill="#cdcdcd"></path></svg>
                  </div>
	               <!-- <a-date-picker class='adatePicker' @change="onChange" formate="YYYY-MM-DD">
					    	 <a-icon slot="suffixIcon" type="smile" />
					      </a-date-picker> -->
							<!-- <template>
							<div style="margin-top:35px;">
								<a-date-picker  @change="onChange" formate="YYYY-MM-DD"/>
								<br />
								<a-month-picker placeholder="请选择学习开始日期" @change="onChange" />
								<br />
								<a-range-picker @change="onChange" />
								<br />
								<a-week-picker placeholder="Select week" @change="onChange" />
							</div>
							</template> -->
						</div>
					</div>
				</div>
				<div class="table-main">
					<p style="border-bottom: none;">
						<a>学习开始时长</a>
						<!-- <span>
							<ul >
								<li v-for="(item,index) in studyLong" :key="index" style="border:1px solid #ff0000;height:30px;line-height:30px;width:50px;" >
									{{item.longLearning}}
								</li>
							</ul>
						</span> -->
					</p>
				</div>
				<div class="table-main" >
					<div class='timebody' v-if='studyLong.length'>
            <!-- studyLong -->
            <div @click="longLearningChange(item,index)"  class='timeActin' v-for="(item,index) in studyLong" :key='index'>
              {{item.longLearning}}
              <svg v-if='svgIndex === index'  t="1631066139257" class="icon timeSvg" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4085" width="28" height="28"><path d="M691.2 725.333333l-38.4-38.4-46.933333 46.933334 81.066666 81.066666 46.933334-46.933333 85.333333-85.333333-42.666667-42.666667-85.333333 85.333333zM896 341.333333v554.666667H341.333333L896 341.333333z" fill="#ea9518" p-id="4086"></path></svg>
            </div>
            <div class='items' v-if='studyLong.length%4!=0'></div>
            <!-- <div class='items' v-if='studyLong.length%4!=0'></div> -->
					<!-- <a-radio-group default-value="item.longLearning" size="large" v-for="(item,index) in studyLong" :key="index"> 
						<a-radio-button  @click="longLearningChange(item)" 
            :longLearning="item.longLearning" 
            :endTime="item.endTime" 
            :startTime="item.startTime"
            :discountAmount="item.discountAmount" 
            :costAmount="item.costAmount" 
            :offerAmount="item.offerAmount"
            :value="item.endTime" 
           
            style="margin-left:10%; font-size:12px;width:100px;text-align:center;">
						{{item.longLearning}}
						</a-radio-button>
					</a-radio-group> -->
					</div>
				</div>
				<div class="table-main table_dev ">
					<div class='_p'>
						<div>结束时间(根据学习时长自动计算)</div>
						<div  v-if='form.endTime'>{{form.endTime}}</div>
					</div>
				</div>
				<div id="money">
					<p>
						<a>原价</a>
						<span id="yuanjia">{{form.costAmount}} 元</span>
					</p>
					<p>
						<a>优惠金额</a>
						<span id="youhui">{{form.offerAmount}}元</span>
					</p>
					<p style="border: none;">
						<a>支付金额</a>
						<span id="xuyao">{{form.discountAmount}}元</span>
					</p>
				</div>
				<div class="table-main" v-if="form.discountAmount > 0">
					<p style="border: none;" v-if="invoiceId == '' || invoiceId == null">
						<a>开具发票</a>
						<span v-if="type != '1'" style="cursor: pointer;" class="fp fps" @click="fp(2)">不要发票</span>
						<span v-else style="cursor: pointer;" class="fp" @click="fp(2)">不要发票</span>
						<span v-if="type == '1'" style="cursor: pointer;" class="fp fps" @click="fp(1)">开发票</span>
						<span v-else style="cursor: pointer;" class="fp" @click="fp(1)">开发票</span>
					</p>
					<p style="border: none;" v-else>
						<a>开具发票</a>
						<span style="cursor: pointer;" class="fp11">不要发票</span>
						<span style="cursor: pointer;" class="fp11 fps">开发票</span>
					</p>
				</div>
				<div v-if="type == '1' && form.discountAmount > 0" style="background: #fff;">
					<van-collapse v-model="activeNames">
					
						<van-collapse-item title="发票信息" name="1">
							<!-- <div class="table-main"><p><a>发票信息</a><span style="cursor: pointer;">点击填写发票信息</span></p></div> -->
							<!-- <div class="table-kfp"><p>发票信息</p></div> -->
							<!-- <div class="table-main1">
								<p>
									<a>发票类型</a>
									<span v-text="form1.invoiceType"></span>
								</p>
							</div> -->
              	<div class="table-main1 table_b">
								<p>
									<a>发票明细</a>
									<input class="inputs" type="text" v-model.trim="mx" disabled placeholder="输入个人或企业名称" />
								</p>
							</div>
            	<div class="table-main1 table_b table_div">
							<div class='mx'>发票类型</div>
               <div class='mx1' v-if="invoiceId != '' || invoiceId != null">
					      	<div id="gs" v-if="form1.invoiceHead == '2'">公司（普通电子发票)</div>
						    	<div id="gs" v-if="form1.invoiceHead == '1'">个人（普通电子发票)</div>
					    	</div>
							</div>
					
							<div class="table-main1 table_b">
								<div class='table_type'>
									<div class='table_test'>抬头类型</div>
                  <radio-group v-if='!isDisabled' class='table_radio' v-model="form1.invoiceHead">
                      <radio name="2" checked-color="#f63c45" icon-size="18px">公司</radio>
                      <radio name="1" checked-color="#f63c45" icon-size="18px">个人</radio>
                  </radio-group>
                  <div class='table_radio' style="font-size: .32rem;color: #333;" v-else>{{form1.invoiceHead+'' === "2"?'公司':'个人'}}</div>
									<!-- <span>
										<input type="radio" :disabled="disableds" name="love" v-model="form1.invoiceHead" value="2" />
										公司
										<input style="margin-left: 0.5rem;" type="radio" :disabled="disableds" name="love" v-model="form1.invoiceHead" value="1" />
										个人
									</span> -->
								</div>
							</div>
							
							

							<div class="table-main1 table_b">
								<p>
									<a>发票抬头</a>
									<input class="inputs" type="text" v-model.trim="form1.invoiceCompe" :disabled="disableds" placeholder="输入个人或企业名称" />
								</p>
							</div>
							<div class="table-main1 table_b" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>税号</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入企业纳税人识别码" v-model.trim="form1.socialCreditCode" />
								</p>
							</div>
							
							<div class="table-main1" v-if="form1.invoiceHead == 1">
								<p style="border: none;">
									<a>身份证号</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入身份证号" v-model.trim="form1.socialCreditCode" />
								</p>
							</div>
							
							<div class="table-main1 table_b" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>开户银行</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入开户银行" v-model="form1.bankName" />
								</p>
							</div>
							
							<div class="table-main1 table_b" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>银行账号</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入银行账号" v-model="form1.bankNumber" />
								</p>
							</div>
							
							<div class="table-main1 table_b" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>企业地址</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入企业地址" v-model="form1.address" />
								</p>
							</div>
							
							<div class="table-main1" v-if="form1.invoiceHead == 2">
								<p style="border: none;">
									<a>企业电话</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入企业电话" v-model="form1.phone" />
								</p>
							</div>
							

							<div class="table-kfp"><p>接收方式</p></div>
							<div class="table-main1">
								<p>
									<a>邮箱</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="用于向您发送电子发票" v-model="form1.invoiceEmail" />
								</p>
							</div>
							<div class="table-main1">
								<p style="border: none;">
									<a>手机号</a>
									<input class="inputs" type="text" :disabled="disableds" placeholder="输入手机号" v-model="form1.invoicePhone" />
								</p>
							</div>
							
							
							<div class="table-kfp"><p>发票总额</p></div>
							<div class="table-main1">
								<p style="border: none;">
									<a>总金额</a>
									<span style="margin-left: 0.2rem;">元</span>
									<input class="inputs" type="text" placeholder="输入金额" v-model="form.discountAmount" disabled style="width: 30%;" />
								</p>
							</div>
							<div class="table-mainss" v-if="this.invoiceId == ''">
								<span style="cursor: pointer;float: left;" class="fpss" :disabled="disableds" @click="qx">取消填写</span>
								<span style="cursor: pointer;float: right;" class="fpss1" @click="qd" :disabled="disableds">确定发票信息</span>
							</div>
						</van-collapse-item>
					</van-collapse>
				</div>
<!-- 
				<div v-if="repeatBtn == 1">
          <div v-if="repeatBtn == 1">
					<div v-if="form.isToll == '2'" id="btn" @click="zf1">支付订单</div>
					<div v-else id="btn" @click="zf">支付订单</div>
				</div>
				<div v-if="repeatBtn == 2"><div id="btn">支付订单</div></div> -->

        <div style='display: flex;justify-content: center;'>
            <van-button id="btn" @click="zfNew" :disabled='isSHow' plain>支付订单</van-button>
        </div>

     
			</div>
		</div>
    <!-- 时间选择器 -->
    
    <popup v-model="show" position="bottom" :style="{ height: '40%',overflow: 'hidden'}" >
        <datetime-picker
        @confirm='confirm'
        @cancel='show=false'
       v-model="currentDate"
       type="date"
       title="选择年月日"
       :min-date="minDate"
       :max-date="maxDate"
       :formatter="formatter"
        />
    </popup>
  <div class='loadings' v-if='isShow'>
			<svg t="1631083218420" class="icon svg_icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5487" width="25" height="25"><path d="M480 96a32 32 0 0 1 64 0v192a32 32 0 0 1-64 0V96z m250.624 60.64a32 32 0 1 1 51.776 37.632L669.568 349.6a32 32 0 0 1-51.808-37.632L730.624 156.64zM897.76 353.024a32 32 0 1 1 19.776 60.864l-182.624 59.328a32 32 0 0 1-19.776-60.864l182.624-59.328z m19.776 257.088a32 32 0 1 1-19.776 60.864l-182.624-59.328a32 32 0 0 1 19.776-60.864l182.624 59.328zM782.4 829.76a32 32 0 0 1-51.776 37.632L617.76 712.064a32 32 0 1 1 51.808-37.632L782.4 829.76zM544 928a32 32 0 0 1-64 0V736a32 32 0 0 1 64 0v192z m-250.624-60.64a32 32 0 0 1-51.776-37.632L354.432 674.4a32 32 0 0 1 51.808 37.632L293.376 867.36zM126.24 670.976a32 32 0 1 1-19.776-60.864l182.624-59.328a32 32 0 0 1 19.776 60.864L126.24 670.976z m-19.776-257.088a32 32 0 0 1 19.776-60.864l182.624 59.328a32 32 0 1 1-19.776 60.864l-182.624-59.328zM241.6 194.24a32 32 0 1 1 51.776-37.632L406.24 311.936a32 32 0 1 1-51.808 37.632L241.6 194.24z" p-id="5488" fill="#ffffff"></path></svg>
			<div style="height:100%">
				订单生成中...
			</div>
		</div>
	</div>
</template>
<script>
import {
  Toast,
  Sidebar,
  List,
  SidebarItem,
  PullRefresh,
  Overlay,
  Tab,
  Tabs,
  Cell,
  Loading,
  Collapse,
  CollapseItem,
  Button,
  radioGroup,
  radio,
  Notify,
  datetimePicker,
  popup,
} from "vant";
import request from "@/utils/request";
// import DatePicker from 'ant-design-vue/lib/date-picker'; // 加载 JS
// import 'ant-design-vue/lib/date-picker/style/css'; // 加载 CSS

import { DatePicker } from "ant-design-vue";

export default {
  components: {
    popup,
    datetimePicker,
    radioGroup,
    radio,
    [Toast.name]: Toast,
    [Sidebar.name]: Sidebar,
    [List.name]: List,
    [SidebarItem.name]: SidebarItem,
    [PullRefresh.name]: PullRefresh,
    [Overlay.name]: Overlay,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Cell.name]: Cell,
    [Loading.name]: Loading,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Button.name]: Button,
    [Notify.name]: Notify,
  },
  data() {
    return {
      isBur: true,
      show:false,
      isDisabled:false,
      minDate: null,
      maxDate: null,
      currentDate: null,
      isSHow:true,
      isShow:false,
    svgIndex: 0,
    discountAmount: 0.01,
		costAmount: 0.01,
		offerAmount: 0,
	  longLearning:'',
	  endTime:'',
      mx: "培训费",
      ys: "1",
      type: "1",
      types: "1",
      repeatBtn: "1",
      aaa: "广东省公路三类人员培训考试",
      activeNames: ["1"],
      disableds: false,
      openid: "",
      invoiceId: "",
        startTime:'',
      form: {
        subsystemId: "",
        startTime:'',
        longLearning: "",
        discountAmount: "",
        costAmount: "",
        offerAmount: "",
        endTime: "",
        studyLongList: [],
        discountAmount: 0,
        costAmount:0,
        offerAmount: 0
      },
      form1: {
        invoiceType: "电子普通发票",
        invoiceHead: "2",
        invoiceCompe: "",
        socialCreditCode: "",
        invoiceEmail: "",
        invoicePhone: "",
        amount: "",
        address: "",
        bankName: "",
        bankNumber: "",
        phone: "",
      },
      // 支付
      form2: {
        openid: "",
        subsystemId: "",
        buyType: "",
        payType: "",
        invoiceId: "",
        isInvoice: "",
      },
      // 月 半年 一年
      form3: {
        dateTimeString: "", //2019年12月
        costAmount: "", //1
        offerAmount: "", //	0.99
        discountAmount: "", //0.01,
      },
      form4: {},

      isInvoice: "1", //是否开发票
      buyType: "1", //购买月份
      payType: "2", //支付方式
      dateTimeString: "", //2019年12月
      costAmount: "", //1
      offerAmount: "", //	0.99
      discountAmount: "", //0.01,

      dateTimeString1: "", //2019年12月
      costAmount1: "", //1
      offerAmount1: "", //	0.99
      discountAmount1: "", //0.01,

      dateTimeString2: "", //2019年12月
      costAmount2: "", //1
      offerAmount2: "", //	0.99
      discountAmount2: "", //0.01,
	  studyLong:[]
    };
  },
  created() {
    let _this = this;
    _this.openid = localStorage.getItem("openid");
    // alert(localStorage.getItem('openid'))
    let urls = Global.env + Global.apiCore.getPaymentContinueEducation;

    return new Promise((resolve, reject) => {
      request({
        url: urls,
        method: "get", //查询一般为get
        params: {
          subsystemId: _this.$route.query.subsystemId,
        }, //get
      })
        .then((response) => {
          if (response.resultCode == "1000") {
            _this.form = response.data;
            _this.form.subsystemName = response.data.subsystemName;
            _this.form.studentName = response.data.studentName;
            _this.form.startTime = response.data.startTime;

            _this.form.longLearning = response.data.longLearning;
            _this.form.discountAmount = response.data.discountAmount;
            _this.form.costAmount = response.data.costAmount;
            _this.form.offerAmount = response.data.offerAmount;
            _this.form.endTime = response.data.endTime;
             this.minDate = new Date(response.data.min*1);
             this.maxDate = new Date(response.data.max*1);
             this.currentDate = new Date(response.data.min*1)
            // if (_this.form.costMode == '2') {

            // 	_this.form3.dateTimeString = response.data.costModeVOList[0].dateTimeString;
            // 	_this.form3.costAmount = response.data.costModeVOList[0].costAmount;
            // 	_this.form3.offerAmount = response.data.costModeVOList[0].offerAmount;
            // 	_this.form3.discountAmount = response.data.costModeVOList[0].discountAmount;

            // 	_this.dateTimeString = response.data.costModeVOList[0].dateTimeString;
            // 	_this.costAmount = response.data.costModeVOList[0].costAmount;
            // 	_this.offerAmount = response.data.costModeVOList[0].offerAmount;
            // 	_this.discountAmount = response.data.costModeVOList[0].discountAmount;

            // 	_this.dateTimeString1 = response.data.costModeVOList[1].dateTimeString;
            // 	_this.costAmount1 = response.data.costModeVOList[1].costAmount;
            // 	_this.offerAmount1 = response.data.costModeVOList[1].offerAmount;
            // 	_this.discountAmount1 = response.data.costModeVOList[1].discountAmount;

            // 	_this.dateTimeString2 = response.data.costModeVOList[2].dateTimeString;
            // 	_this.costAmount2 = response.data.costModeVOList[2].costAmount;
            // 	_this.offerAmount2 = response.data.costModeVOList[2].offerAmount;
            // 	_this.discountAmount2 = response.data.costModeVOList[2].discountAmount;
            // } else {
            // 	_this.form3.costAmount = _this.form.costAmount;
            // 	_this.form3.offerAmount = _this.form.offerAmount;
            // 	_this.form3.discountAmount = _this.form.discountAmount;
            // }

          }
        })
        .catch((error) => {
          Dialog.alert({
            message: error.errmsg,
          }).then(() => {
            // on close
          });
          return reject(error);
        });
    });
  },
  methods: {
    // 时间选择器
    btn_show(){
      if(!this.isBur){
         Toast('发票已生成,请返回上一页重新选择～')
         return
      }
      this.show = true
    },
	longLearningChange(e,index){
    if(!this.isBur) {
        Toast('发票已生成,请返回上一页重新选择～')
        return
    }
    this.svgIndex = index
		this.endTime=e.endTime
    	this.form.endTime=e.endTime
			this.form.discountAmount=e.discountAmount
			this.form.costAmount=e.costAmount
			this.form.offerAmount=e.offerAmount
      this.form.startTime=this.startTime
      this.form.longLearning=e.longLearning
  },
gettime(data) {
    let value = data.getFullYear() + '-' +
      this.checkTime(data.getMonth() + 1) + '-' +
      this.checkTime(data.getDate())
    return value
  },
  checkTime(i) {
    if (i < 10) {
      i = "0" + i
    }
    return i;
  },


  confirm(date){
   let _time = this.gettime(date)
   this.show = false
   this.svgIndex = 0
    this.onChange(_time)

  },
   formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }else{
        return `${val}日`;
      }
      return val;
    
  },
    onChange(dateString) {
    var reg =/(\d{4})\-(\d{2})\-(\d{2})/;
    var dateString = dateString.replace(reg,"$1年$2月$3日");
   this.startTime = dateString
	  this.form.startTime=dateString
      let _this = this;
      _this.form.startTime=dateString
      _this.startTime=dateString
      let url = Global.env + Global.apiCore.getPaymentContinueEducationEndTime;
      return new Promise((resolve, reject) => {
        request({
          url: url,
          method: "get", //查询一般为get
          params: {
            subsystemId: _this.$route.query.subsystemId,
            startTime: dateString,
          },
        })
          .then((response) => {
            if (response.resultCode === "1000") {
              if (response && response.data) {
                let dataObj = response.data;
                if(dataObj.length != 0) {
                  this.isSHow = false
                }
                _this.studyLong=dataObj
                this.form.costAmount=dataObj[0].costAmount
                this.form.discountAmount = dataObj[0].discountAmount
                this.form.endTime = dataObj[0].endTime
                this.form.offerAmount =dataObj[0].offerAmount
                 this.form.longLearning=dataObj[0].longLearning
              }
              return resolve();
            } else {
              return reject(response.resultDesc);
            }
          })
          .catch((error) => {
            return reject(error);
          });
      });



    },
    fanhui() {
      this.$router.push({
        name: "FilterSystem",
        query: {},
      });
    },
    setPayTypes(e) {
      let _this = this;
      _this.buyType = e;
      if (e == 1) {
        this.ys = "1";
        this.form3.dateTimeString = this.dateTimeString;
        this.form3.costAmount = this.costAmount;
        this.form3.offerAmount = this.offerAmount;
        this.form3.discountAmount = this.discountAmount;
      } else if (e == 6) {
        this.ys = "2";
        this.form3.dateTimeString = this.dateTimeString1;
        this.form3.costAmount = this.costAmount1;
        this.form3.offerAmount = this.offerAmount1;
        this.form3.discountAmount = this.discountAmount1;
      } else if (e == 12) {
        this.ys = "3";
        this.form3.dateTimeString = this.dateTimeString2;
        this.form3.costAmount = this.costAmount2;
        this.form3.offerAmount = this.offerAmount2;
        this.form3.discountAmount = this.discountAmount2;
      }
    },
    fp(e) {
      let _this = this;
      _this.isInvoice = e;
      // alert(_this.form2.isInvoice)
      if (e == 1) {
        this.type = "1";
      } else {
        this.type = "";
        this.activeNames = [];
      }
    },
    qx() {
      let _this = this;
      _this.activeNames = [];
    },
    qd() {
    
      let _this = this;
      if (_this.form1.invoiceCompe == "") {
        Notify("发票抬头不能为空");
        return false;
      }
      if (!isNaN(Number(_this.form1.invoiceCompe))) {
        //当输入不是数字的时候，Number后返回的值是NaN;然后用isNaN判断。
        Notify("请输入正确发票抬头");
        return false;
      }
      if (_this.form1.invoiceHead == "2") {
        if (_this.form1.socialCreditCode == "") {
          Notify("税号不能为空");
          return false;
        }
      } else {
        let socialCreditCode = /^\d{15}|\d{18}$/;
        if (!socialCreditCode.test(_this.form1.socialCreditCode)) {
          Notify("身份证格式不正确");
          _this.form1.socialCreditCode.invoiceEmail = "";
          return false;
        }
      }
      let invoiceEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!invoiceEmail.test(this.form1.invoiceEmail)) {
        Notify("邮箱格式不正确");
        this.form1.invoiceEmail = "";
        return false;
      }
      let invoicePhone = /^1[0-9]{10}$/;
      if (!invoicePhone.test(this.form1.invoicePhone)) {
        Notify("手机号格式不正确");
        this.form1.invoicePhone = "";
        return false;
      }
      if (_this.form1.invoiceHead == "2") {
        if (_this.form1.address == "") {
          Notify("企业不能为空");
          return false;
        }
      }
      let phone = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
      if (_this.form1.invoiceHead == "2") {
        if (!phone.test(this.form1.phone)) {
          Notify("企业电话格式不正确");
          this.form1.phone = "";
          return false;
        }
      }

  
      let urls = Global.env + Global.apiCore.invoiceAdd;
      return new Promise((resolve, reject) => {
        request({
          url: urls,
          method: "post", //查询一般为get
          data: {
            invoiceType: _this.form1.invoiceType,
            invoiceHead: _this.form1.invoiceHead,
            invoiceCompe: _this.form1.invoiceCompe,
            socialCreditCode: _this.form1.socialCreditCode,
            invoiceEmail: _this.form1.invoiceEmail,
            invoicePhone: _this.form1.invoicePhone,
            address: _this.form1.address,
            bankName: _this.form1.bankName,
            bankNumber: _this.form1.bankNumber,
            phone: _this.form1.phone,
            amount: _this.form.discountAmount
          }, //get
        })
          .then((response) => {
            if (response.resultCode == "1000") {
              _this.invoiceId = response.data.id;
              _this.activeNames = [];
              _this.disableds = true;
              _this.isBur = false;
              _this.isDisabled = true
            }
          })
          .catch((error) => {
            Dialog.alert({
              message: error.errmsg,
            }).then(() => {
              // on close
            });
            return reject(error);
          });
      });
    },
    zf1() {
      Notify("存在有效订单，不允许缴费。");
    },
    zfNew(){
      let _this = this;
    
        this.isSHow = true
        this.isShow = true
        let urls = Global.env + Global.apiCore.zf;
        return new Promise((resolve, reject) => {
          request({
            url: urls,
            method: "post", //查询一般为get
            data: {
              openid: _this.openid,
              subsystemId: _this.$route.query.subsystemId,
              payType: "2",
              invoiceId: _this.invoiceId,
              isInvoice: _this.isInvoice,
              longLearning: _this.form.longLearning,
              startTime: _this.form.startTime
            
            }, //get
          })
            .then((response) => {
              if (response.resultCode == "1000") {
                this.isShow = false
              function onBridgeReady() {
                  WeixinJSBridge.invoke(
                    "getBrandWCPayRequest",
                    {
                      appId: response.data.appId, //公众号名称，由商户传入
                      timeStamp: response.data.timeStamp, //时间戳，自1970年以来的秒数
                      nonceStr: response.data.nonceStr, //随机串
                      package: response.data.package,
                      signType: response.data.signType, //微信签名方式：
                      paySign: response.data.paySign, //微信签名
                    },
                    function (res) {
                       _this.isSHow = false
                      // alert('res')
                      _this.repeatBtn = "1";
                      if (res.err_msg == "get_brand_wcpay_request:ok") {
                        // alert("ok")
                        // window.location.href = 'http://m-test.jiaodao11.com/PaymentResult';
                        window.location.href =
                          "https://m.jiaodao11.com/PaymentResult";
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                      }
                    }
                  );
                }   
                onBridgeReady()
                // window.location.href = "https://m.jiaodao11.com/PaymentResult";
              } else {
                 _this.isSHow = false
                  _this.isShow = false
                Notify(response.resultDesc);
              }
            })
            .catch((error) => {
          _this.isSHow = false
          _this.isShow = false
              Notify(error.errmsg);
              return reject(error);
            });
        });
      
    },
    zf() {
      let _this = this;
      _this.repeatBtn = "2";
      if (
        _this.form.discountAmount == 0 ||
        _this.form.discountAmount == "" ||
        _this.form.discountAmount == null
      ) {
        let urls = Global.env + Global.apiCore.zeroOrder;
        return new Promise((resolve, reject) => {
          request({
            url: urls,
            method: "post", //查询一般为get
            data: {
              openid: _this.openid,
              subsystemId: _this.$route.query.subsystemId,
              buyType: _this.buyType,
              payType: "2",
              invoiceId: _this.invoiceId,
              isInvoice: _this.isInvoice,
            }, //get
          })
            .then((response) => {
              if (response.resultCode == "1000") {
                _this.repeatBtn = "1";
                window.location.href = "https://m.jiaodao11.com/PaymentResult";
              } else {
                _this.repeatBtn = "1";
                Notify(response.resultDesc);
              }
            })
            .catch((error) => {
              _this.repeatBtn = "1";
              Notify(error.errmsg);
              return reject(error);
            });
        });
      } else {
        // alert(222)
        if (this.isInvoice == "1") {
          if (this.invoiceId == "" || this.invoiceId == null) {
            _this.repeatBtn = "1";
            Notify("请填写发票信息");
            return false;
          }
        }
        let urls = Global.env + Global.apiCore.zf;
        return new Promise((resolve, reject) => {
          request({
            url: urls,
            method: "post", //查询一般为get
            data: {
              openid: _this.openid,
              subsystemId: _this.$route.query.subsystemId,
              buyType: _this.buyType,
              payType: "2",
              invoiceId: _this.invoiceId,
              isInvoice: _this.isInvoice,
            }, //get
          })
            .then((response) => {
              if (response.resultCode == "1000") {
                _this.form4 = response.data;
                // alert(_this.form4.appId);
                // alert(_this.form4.timeStamp);
                // alert(_this.form4.nonceStr);
                // alert(_this.form4.package);
                // alert(_this.form4.paySign);
                // alert('点击支付回调成功');
                //
                function onBridgeReady() {
                  WeixinJSBridge.invoke(
                    "getBrandWCPayRequest",
                    {
                      appId: _this.form4.appId, //公众号名称，由商户传入
                      timeStamp: _this.form4.timeStamp, //时间戳，自1970年以来的秒数
                      nonceStr: _this.form4.nonceStr, //随机串
                      package: _this.form4.package,
                      signType: "MD5", //微信签名方式：
                      paySign: _this.form4.paySign, //微信签名
                    },
                    function (res) {
                      // alert('res')
                      _this.repeatBtn = "1";
                      if (res.err_msg == "get_brand_wcpay_request:ok") {
                        // alert("ok")
                        // window.location.href = 'http://m-test.jiaodao11.com/PaymentResult';
                        window.location.href =
                          "https://m.jiaodao11.com/PaymentResult";
                        // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                      }
                    }
                  );
                }
                onBridgeReady();
              } else {
                _this.repeatBtn = "1";
                Notify(response.resultDesc);
              }
            })
            .catch((error) => {
              _this.repeatBtn = "1";
              Notify(error.errmsg);
              return reject(error);
            });
        });
      }
    },
  },
};
</script>
<style rel="stylesheet/scss" lang="scss">
.fs_12 {
  font-size: 12px;
}
.paymentOrderCon {
  #big {
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #f9f9f9;
  }

  #imgFanhui {
    display: block;
    width: 0.2rem;
    height: 0.36rem;
    position: absolute;
    left: 0.3rem;
    top: 0.26rem;
  }

  #header {
    width: 100%;
    height: 0.98rem;
    line-height: 0.98rem;
    background: #383952;
    text-align: center;
    font-size: 0.36rem;
    font-weight: 400;
    color: #fff;
  }

  #main {
    flex: 1;
    background: #fff;
    overflow-y: auto;
  }

  #nav {
    width: 100%;
    // height: 2rem;
    background: #fff;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
  }

  #nav p {
    /*float: left;*/
    display: inline-block;
    width: 1.46rem;
    height: 0.68rem;
    line-height: 0.68rem;
    text-align: center;
    font-size: 0.36rem;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    border: 1px solid rgba(50, 51, 51, 1);
    margin: 0.32rem 0 0.2rem 0.72rem;
  }

  .ys {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  .ys1 {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  .ys2 {
    color: #f63c45 !important;
    border: 1px solid #f63c45 !important;
  }
  #money {
    width: 100%;
    height: auto;
    background: #fff;
    margin-bottom: 0.2rem;
  }

  #money p {
    width: 92.5%;
    height: 1.12rem;
    line-height: 1.12rem;
    border-bottom: 1px solid rgba(205, 205, 205, 1);
    margin: 0 auto;
  }

  #money p a {
    float: left;
    font-size: 0.32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }

  #money p span {
    float: right;
    font-size: 0.32rem;
    font-weight: 400;
  }

  #money p span a {
    color: rgba(51, 51, 51, 1);
  }

  #need {
    color: rgba(255, 180, 0, 1) !important;
  }

  #btn {
    width: 92.5%;
    height: 0.82rem;
    line-height: 0.82rem;
    background: #f63c45;
    border-radius: 4px;
    margin: 0 auto;
    margin-top: 0.88rem;
    text-align: center;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    font-size: 0.34rem;
    margin-bottom: 0.2rem;
    cursor: pointer;
    overflow: hidden;
  }
  #showTime {
    font-size: 0.32rem;
    line-height: 0.72rem;
    padding-left: 0.7rem;
  }

  .table-main {
    width: 100%;
    height: auto;
    background: #fff;
  }
  .table-main1 {
    width: 100%;
    height: auto;
    background: #fff;
    overflow: hidden;
  }
  .table-main p {
    width: 92.5%;
    height: 1.12rem;
    line-height: 1.12rem;
    margin: 0 auto;
    overflow: hidden;
  }

  .table-main p a {
    float: left;
    font-size: 0.32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }

  .table-main p span {
    float: right;
    font-size: 0.32rem;
    font-weight: 400;
  }

  .table-main p span a {
    color: rgba(51, 51, 51, 1);
  }
  .fp {
    display: block;
    width: 1.52rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }
  .fp:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fp11 {
    display: block;
    width: 1.52rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }

  .fpss {
    display: block;
    width: 2.8rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-bottom: 0.26rem;
    margin-left: 0.3rem;
    border-radius: 4px;
  }
  .fpss1 {
    display: block;
    width: 2.8rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-bottom: 0.26rem;
    margin-right: 0.3rem;
    border-radius: 4px;
  }
  .fpss:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fpss1:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fpxx {
    display: block;
    width: 2.5rem;
    height: 0.62rem;
    line-height: 0.62rem;
    text-align: center;
    color: #333333;
    border: 1px solid #323333;
    margin-top: 0.26rem;
    margin-left: 0.3rem;
  }
  .fpxx:hover {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .fps {
    color: #fff;
    background: #f63c45;
    border-color: #f63c45;
  }
  .table-kfp {
    height: 0.88rem;
    width: 100%;
    background: #f3f3f4;
  }
  .table-kfp p {
    width: 92.5%;
    height: 0.88rem;
    line-height: 0.88rem;
    margin: 0 auto;
    font-size: 0.32rem;
    color: #666666;
  }
  .table-main1 p {
    width: 92.5%;
    height: 1.12rem;
    line-height: 1.12rem;
    margin: 0 auto;
  }

  .table-main1 p a {
    float: left;
    font-size: 0.32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333333;
  }
  .table-main1 p span {
 
    font-size: 0.32rem;
    font-weight: 400;
    margin-left: 0.5rem;
  }

  .table-main1 p span a {
    color: rgba(51, 51, 51, 1);
  }
  .table-main1 .inputs {
    float: right;
    width: 5.2rem;
    height: 1.12rem;
    // line-height: 0.96rem !important;
    text-align: right;
    color: #666666;
    font-size: 0.32rem;
    border: none;
    text-align: left;
  }
  .van-cell {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    margin: 0 auto;
    box-sizing: border-box;
    width: 100%;
    /* padding: .13333rem .21333rem; */
    overflow: hidden;
    color: #323233;
    font-size: 0.32rem !important;
    line-height: 0.32rem;
    background-color: #eee;
    padding: 0.3rem 0.3rem;
    box-sizing: border-box;
    border-bottom: none!important
  }
  #gs {
    font-size: 0.32rem;
    z-index: 99999;
    margin-left: 0.5rem;
  }
  .van-collapse-item__content {
    padding: 0 !important;
    color: #969799;
    font-size: 0.32rem !important;
    line-height: 1.5;
    background-color: #fff;
  }
  input {
    background: #fff;
    border: none;
  }
  input[type="radio"] + label::before {
    content: "\a0"; /*不换行空格*/
    display: inline-block;
    vertical-align: middle;
    font-size: 18px;
    width: 1em;
    height: 1em;
    margin-right: 0.4em;
    border-radius: 50%;
    border: 1px solid #01cd78;
    text-indent: 0.15em;
    line-height: 1;
  }
  ._p{
    // display: flex;
  }
  .time_sct{
    height: 1.12rem;
    
    
  }
  .table_time{
    display: flex;
    align-items: center;
    font-size: .32rem;
    justify-content: space-between;
    width: 92.5%;
    margin: 0 auto;
    // justify-content: ;
  }
  .table_dev{
    width: 92.5%;
    margin: 0 auto;
    font-size: .32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333;
    // height: 1.12rem;
    line-height: 1.12rem;
     border-bottom: .01333rem solid #cdcdcd;
  }
  .createTime{
  // position: relative;
  // flex:0.7;
  display: flex;
  align-items: center;
  .iconsvg1{
    display: flex;
     align-items: center;
     flex: 0.7;
  }
  .iconsvg{
    // position: absolute;
    right: 0;
    bottom: 0;
    top:0.05rem;
  }
  .iconTime{
    // position: absolute;
     bottom: 0;
     top:0;
     right: 0.6rem;
      font-size: .32rem;
      width: 92%;
  }
  .adatePicker{
    opacity: 0;
  }
  
}
  .timebody{
       width: 92.5%;
       display: flex;
       margin: 0 auto;
        flex-wrap: wrap;
          justify-content: space-between;
      .timeActin{
          width: 1.5rem;
          height: 0.6rem;
          text-align: center;
          line-height: 0.6rem;
          border: solid 1px #333;
          position: relative;
          margin-bottom: 0.1rem;
          font-size: 0.3rem;
          .timeSvg{
            position: absolute;
            bottom: -0.08rem;
            right: -0.09rem;

          }
          
    }
    .items{
        width: 1.5rem;
          height: 0.6rem;
          flex: 0.9;
    }
  }
  .van-ellipsis{
    font-size: 0.3rem;
  }
  .van-picker__confirm,.van-picker__cancel{
    font-size: 0.3rem;
  }
.van-picker__title{
  line-height: inherit;
}
.svg_icon{
  margin: 0;
}
.loadings{
		display: flex;
		align-items: center;
		justify-content: center;
		height: 2rem;
		width: 2.5rem;
		text-align: center;
		line-height: 2rem;
		border-radius: 0.4rem;
		background: rgba(0, 0, 0, 0.6);
		position: absolute;
		left: 0;
		right: 0;
		top: 40%;
		color: #fff;
		margin: auto;
    font-size: 0.32rem;
}
.table_b{
    border-bottom: 1px solid rgba(205, 205, 205, 1);
}
.table_div{
  width: 100%;
    height: 1.12rem;
    line-height: 1.12rem;
    margin: 0 auto;
  display: flex;
  padding: 0 0.27rem;
  .mx{
    font-size: .32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333;
  }
  .mx1{
    width: 5.2rem;
    height: 1.12rem;
    text-align: right;
    color: #666;
    font-size: .32rem;
    text-align: left;
  }
}
.table_type{
  display: flex;
      width: 92.5%;
    height: 1.12rem;
    line-height: 1.12rem;
    align-items: center;
    margin: 0 auto;
  .table_test{
    font-size: .32rem;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #333;
    }
  .table_radio{
      display: flex;
      align-items: center;
      margin-left: 0.5rem;
    }
   }
   .van-radio__icon .van-icon{
         line-height: inherit;
   }
   .van-radio{
     margin-right: 0.3rem;
   }
   .van-icon-success:before{
     content: '';
     position: absolute;
     left: 0;
     right: 0;
     top: 0;
     bottom: 0;
     margin: auto;
     z-index: 999;
     width: 0.15rem;
     height: 0.15rem;
     border-radius: 50%;
     background: #fff;
   }
}
</style>
